import { styled, InputProps, Box, Typography, SxProps } from '@mui/material'
import { ThemeColors } from '@theme/colors'
import { ReactElement } from 'react'
import i18n from '@locales/i18n'
interface ClassicTextFieldProps extends InputProps {
  helperText?: string
  label?: string
  error?: boolean
  labelSecondary?: ReactElement
  required?: boolean
  labelStyle?: SxProps
  id: string
}

export const Label = styled('label')({
  padding: '2px 1px',
  fontSize: 12,
  marginRight: '3px',
})

const CustomInputLabel: React.FC<ClassicTextFieldProps> = ({
  label,
  labelSecondary,
  required = false,
  labelStyle,
  id,
}) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center">
        <Label
          sx={{
            fontWeight: 500,
            color: ThemeColors.dark,
            fontSize: 14,
            ...labelStyle,
          }}
          id={id ? id : ''}
        >
          {label}
        </Label>
        {required === true && (
          <Typography
            component="label"
            variant="body1"
            sx={{ border: 1 }}
            style={{
              color: ThemeColors.secondary,
              paddingRight: 5,
              paddingLeft: 5,
              paddingTop: 0,
              marginBottom: 3,
            }}
          >
            {i18n.t('SYSCOMMON.required')}
          </Typography>
        )}
      </Box>
      {labelSecondary}
    </Box>
  )
}

export default CustomInputLabel
